<template>
  <div class="p-5 bg-slate-100 rounded-2xl">
    <div class="mb-4 flex items-center gap-4">
      <BlTextSubtitle1 text="Assessment" />
      <BlInputButton
        type="outlined"
        dense
        label="Edit"
        @clicked="editOpened = true"
      />
    </div>
    <div class="flex flex-col gap-5">
      <!-- assessment observer -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Observer" />
        <BlTextBody2
          :text="assessment.observer || '-'"
          class="text-slate-1000 col-span-3"
        />
      </div>
      <!-- assessment date -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Date" />
        <BlTextBody2
          :text="displayDate(assessment.date)"
          class="text-slate-1000 col-span-3"
        />
      </div>
      <!-- assessment time -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Time" />
        <BlTextBody2
          :text="
            `${assessment.start_time || '...'} - ${assessment.end_time ||
              '...'}`
          "
          class="text-slate-1000 col-span-3"
        />
      </div>
      <!-- assessment antecedent -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Antecedent" />
        <BlTextBody2
          :text="assessment.antecedent || '-'"
          class="text-slate-1000 col-span-3 whitespace-pre-line"
        />
      </div>
      <!-- assessment behavior -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Behavior" />
        <BlTextBody2
          :text="assessment.behavior || '-'"
          class="text-slate-1000 col-span-3 whitespace-pre-line"
        />
      </div>
      <!-- assessment consequence -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Consequence" />
        <BlTextBody2
          :text="assessment.consequence || '-'"
          class="text-slate-1000 col-span-3 whitespace-pre-line"
        />
      </div>
      <!-- assessment potential reasons for behavior -->
      <div class="grid grid-cols-4 gap-x-4">
        <BlTextBody2 class="mt-0.5" text="Potential reasons for behavior" />
        <div class="col-span-3">
          <BlTextBody2
            :text="potentialReasonsForBehavior.join(', ') || '-'"
            class="text-slate-1000"
          />
        </div>
      </div>
    </div>
    <EditAssessmentModal
      v-if="editOpened"
      :assessment="assessment"
      @close-modal="editOpened = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

import EditAssessmentModal from "./EditAssessmentModal.vue";

import BlTextSubtitle1 from "../../BlTextSubtitle1.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";
import BlBackdrop from "../../BlBackdrop.vue";

export default {
  name: "ClientAboutAssessment",
  components: {
    EditAssessmentModal,
    BlTextSubtitle1,
    BlTextBody2,
    BlInputButton,
    BlBackdrop
  },
  props: {
    assessment: { type: Object, required: true }
  },
  data() {
    return {
      editOpened: false
    };
  },
  computed: {
    ...mapGetters(["client"]),
    potentialReasonsForBehavior() {
      let arr = [];
      // prettier-ignore
      if (this.assessment) {
        if (this.assessment.escape_or_avoidance) arr.push("Escape/Avoidance");
        if (this.assessment.expression_of_anger) arr.push("Expression of Anger");
        if (this.assessment.obtain_tangible_item) arr.push("Obtain Tangible Item");
        if (this.assessment.fear_or_anxiety) arr.push("Fear/Anxiety");
        if (this.assessment.gaining_attention) arr.push("Gaining Attention");
        if (this.assessment.frustation) arr.push("Frustration");
        if (this.assessment.sensory_stimulation) arr.push("Sensory Stimulation");
        if (this.assessment.other) arr.push("Other");
      }
      return arr;
    }
  },
  methods: {
    ...mapActions(["deleteAssessment"]),
    displayDate(date, format = "DD/MM/YYYY") {
      if (!date) return "-";
      return moment(date).format(format);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/clients/about/Assessment.vue